var _path, _path2, _path3, _path4, _g, _g2, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRocketlaunch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 187,
    height: 181,
    viewBox: "0 0 187 181",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 177.429C0 125.855 41.8078 84.0474 93.3813 84.0474C144.955 84.0474 186.763 125.855 186.763 177.429",
    fill: "#DDE3FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M136.701 148.667C136.109 148.667 135.528 148.701 134.955 148.765C133.854 146.122 132.271 143.735 130.314 141.703C130.344 141.314 130.363 140.922 130.363 140.522C130.363 131.775 123.274 124.686 114.526 124.686C105.783 124.686 98.6902 131.775 98.6902 140.522C96.081 142.856 94.0147 145.786 92.695 149.097C90.2932 149.666 88.0987 150.778 86.2587 152.305C86.1983 152.222 86.1418 152.139 86.0852 152.06C88.0384 149.425 89.1959 146.167 89.1959 142.634C89.1959 133.886 82.1073 126.798 73.3597 126.798C64.612 126.798 57.5234 133.886 57.5234 142.634C57.5234 144.044 57.7081 145.409 58.055 146.71C57.0784 146.521 56.0717 146.419 55.0423 146.419C46.2947 146.419 39.2061 153.508 39.2061 162.256C39.2061 171.003 46.2947 178.092 55.0423 178.092C58.6998 178.092 62.0631 176.852 64.744 174.77C67.225 176.384 70.1811 177.323 73.3634 177.323C77.2018 177.323 80.7235 175.954 83.4647 173.684C86.3266 177.711 91.0322 180.339 96.3562 180.339C99.2407 180.339 101.944 179.563 104.274 178.216C107.197 179.578 110.451 180.339 113.889 180.339C118.531 180.339 122.848 178.948 126.449 176.569C129.213 178.918 132.791 180.339 136.701 180.339C145.449 180.339 152.537 173.251 152.537 164.503C152.537 155.755 145.449 148.667 136.701 148.667Z",
    fill: "#F5F6F8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M107.613 26.1021H80.5742V124.219H107.613V26.1021Z",
    fill: "#5B73E8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0954 0C82.1955 11.8998 80.5742 26.1035 80.5742 26.1035H94.0954H107.617C107.617 26.1035 105.995 11.8998 94.0954 0Z",
    fill: "#3654E3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.54
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.629 46.8623C100.629 50.4745 97.7031 53.4005 94.0909 53.4005C90.4787 53.4005 87.5527 50.4745 87.5527 46.8623C87.5527 43.2502 90.4787 40.3242 94.0909 40.3242C97.7031 40.3242 100.629 43.2502 100.629 46.8623Z",
    fill: "#D3D3D3"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.54
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.0928 73.0274C97.7037 73.0274 100.631 70.1002 100.631 66.4893C100.631 62.8784 97.7037 59.9512 94.0928 59.9512C90.4819 59.9512 87.5547 62.8784 87.5547 66.4893C87.5547 70.1002 90.4819 73.0274 94.0928 73.0274Z",
    fill: "#D3D3D3"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9638 66.4863C98.9638 69.1785 96.7844 71.3578 94.0922 71.3578C91.4001 71.3578 89.2207 69.1785 89.2207 66.4863C89.2207 63.7979 91.4001 61.6147 94.0922 61.6147C96.7844 61.6147 98.9638 63.7979 98.9638 66.4863Z",
    fill: "#D3D3D3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9638 46.8608C98.9638 49.5492 96.7844 51.7323 94.0922 51.7323C91.4001 51.7323 89.2207 49.553 89.2207 46.8608C89.2207 44.1686 91.4001 41.9893 94.0922 41.9893C96.7844 41.9893 98.9638 44.1686 98.9638 46.8608Z",
    fill: "#D3D3D3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5166 124.515H77.627V149.518H83.5166V124.515Z",
    fill: "#F34E4E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M97.0419 124.515H91.1523V149.518H97.0419V124.515Z",
    fill: "#F34E4E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M110.56 124.515H104.67V149.518H110.56V124.515Z",
    fill: "#F34E4E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9638 127.112H89.2207C89.2207 124.42 91.4001 122.241 94.0922 122.241C96.7844 122.241 98.9638 124.424 98.9638 127.112Z",
    fill: "#3654E3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M112.487 127.112H102.744C102.744 124.42 104.927 122.24 107.616 122.24C110.304 122.24 112.487 124.423 112.487 127.112Z",
    fill: "#3654E3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4462 127.112H75.7031C75.7031 124.42 77.8825 122.24 80.5747 122.24C83.2668 122.24 85.4462 124.423 85.4462 127.112Z",
    fill: "#3654E3"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M124.232 177.559H114.387V70.6113H124.232V177.559ZM115.058 176.888H123.557V71.2863H115.058V176.888Z",
    fill: "#5B73E8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M123.683 172.017L114.511 176.852L114.908 177.606L124.081 172.771L123.683 172.017Z",
    fill: "#5B73E8"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M123.683 155.673L114.511 160.508L114.908 161.262L124.081 156.427L123.683 155.673Z",
    fill: "#5B73E8"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M123.683 139.325L114.511 144.16L114.908 144.913L124.081 140.078L123.683 139.325Z",
    fill: "#5B73E8"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M123.697 122.992L114.525 127.83L114.923 128.584L124.094 123.746L123.697 122.992Z",
    fill: "#5B73E8"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M123.697 106.655L114.525 111.493L114.923 112.247L124.094 107.409L123.697 106.655Z",
    fill: "#5B73E8"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M123.689 90.2771L114.518 95.1143L114.915 95.868L124.086 91.0308L123.689 90.2771Z",
    fill: "#5B73E8"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M123.689 73.9319L114.518 78.769L114.915 79.5228L124.086 74.6856L123.689 73.9319Z",
    fill: "#5B73E8"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5441 177.56H61.6992V70.6118H71.5441V177.56ZM62.3704 176.888H70.8692V71.2867H62.3704V176.888Z",
    fill: "#5B73E8"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0005 172.013L61.8281 176.848L62.2255 177.602L71.3979 172.767L71.0005 172.013Z",
    fill: "#5B73E8"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0005 155.668L61.8281 160.503L62.2255 161.257L71.3979 156.422L71.0005 155.668Z",
    fill: "#5B73E8"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0005 139.323L61.8281 144.158L62.2255 144.912L71.3979 140.077L71.0005 139.323Z",
    fill: "#5B73E8"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0122 122.99L61.8408 127.829L62.2384 128.582L71.4098 123.744L71.0122 122.99Z",
    fill: "#5B73E8"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0132 106.654L61.8418 111.492L62.2394 112.246L71.4108 107.408L71.0132 106.654Z",
    fill: "#5B73E8"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0073 90.2771L61.8359 95.1143L62.2335 95.868L71.4048 91.0308L71.0073 90.2771Z",
    fill: "#5B73E8"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0073 73.9324L61.8359 78.7695L62.2335 79.5233L71.4048 74.6861L71.0073 73.9324Z",
    fill: "#5B73E8"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4862 106.967C32.4824 106.967 32.4824 106.967 32.4785 106.967C32.5093 106.979 32.5132 106.983 32.4862 106.967Z",
    fill: "#3654E3"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M28.744 76.741H51.371C51.371 76.741 53.2978 72.3558 47.6495 71.5829C42.0012 70.8137 48.9315 67.571 43.0268 67.0582C37.1221 66.5454 41.6204 71.9674 35.5837 71.1983C29.5509 70.4291 26.097 73.125 27.9521 73.3814C29.8035 73.6378 12.7908 76.741 28.744 76.741Z",
    fill: "#5B73E8"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M60.5764 57.4163H83.1997C83.1997 57.4163 85.1264 53.0311 79.4781 52.2582C73.8299 51.489 80.7601 48.2463 74.8555 47.7335C68.9508 47.2207 73.449 52.6428 67.4124 51.8736C61.3795 51.1044 57.9257 53.8003 59.7808 54.0567C61.6359 54.3131 44.627 57.4163 60.5764 57.4163Z",
    fill: "#5B73E8"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M137.243 95.1477H159.87C159.87 95.1477 161.797 90.7626 156.149 89.9896C150.501 89.2204 157.431 85.9777 151.526 85.4649C145.622 84.9521 150.12 90.3742 144.083 89.605C138.05 88.8358 134.597 91.5317 136.452 91.7881C138.307 92.0445 121.294 95.1477 137.243 95.1477Z",
    fill: "#5B73E8"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M107.518 57.4163H130.145C130.145 57.4163 132.072 53.0311 126.423 52.2582C120.775 51.489 127.705 48.2463 121.801 47.7335C115.896 47.2207 120.394 52.6428 114.358 51.8736C108.321 51.1044 104.871 53.8003 106.726 54.0567C108.581 54.3131 91.5684 57.4163 107.518 57.4163Z",
    fill: "#5B73E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocketlaunch);
export default __webpack_public_path__ + "static/media/Rocket launch.d76017de1e6cbe73dd18987423bd1ab5.svg";
export { ForwardRef as ReactComponent };